"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeTranslation = exports.readExcel = void 0;
const XLSX = __importStar(require("xlsx"));
const spreadsheet_1 = require("common/spreadsheet");
const bookParser_1 = require("@/utils/bookParser");
const parseFile_1 = require("utils/parseFile");
const readFile = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            const data = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
            resolve(data);
        };
        reader.readAsBinaryString(file);
    });
};
const readExcel = (rawFile) => __awaiter(void 0, void 0, void 0, function* () {
    const fileData = yield readFile(rawFile);
    const workbook = XLSX.read(fileData, { type: "binary" });
    return workbook;
});
exports.readExcel = readExcel;
const writeTranslation = (workbook, records, option) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const translationMap = {};
    records === null || records === void 0 ? void 0 : records.forEach(({ scriptId, text, translations }) => {
        translationMap[scriptId] = { text, translations };
    });
    const readReplica = yield (0, exports.readExcel)((0, parseFile_1.bookToBlob)(workbook));
    const parser = new bookParser_1.BookParser(option);
    const scripts = parser.parse((0, spreadsheet_1.openXLSXBook)(readReplica));
    // Create a map of all aliases to their normalized language code
    const aliasToLangMap = {};
    if (option.langAliases) {
        Object.entries(option.langAliases).forEach(([langId, aliases]) => {
            aliases.forEach((alias) => {
                aliasToLangMap[alias] = langId;
            });
            // Also map the language ID to itself
            aliasToLangMap[langId] = langId;
        });
    }
    // Get all available languages from aliases configuration
    const availableLanguages = new Set();
    if (option.langAliases) {
        Object.keys(option.langAliases).forEach((langId) => {
            availableLanguages.add(langId);
        });
    }
    // Also add any additional languages from translations that might not be in aliases
    records === null || records === void 0 ? void 0 : records.forEach(({ translations }) => {
        if (translations) {
            Object.keys(translations).forEach((lang) => {
                // Normalize the language code using our alias map
                const normalizedLang = aliasToLangMap[lang] || lang;
                availableLanguages.add(normalizedLang);
            });
        }
    });
    // Get the maximum column index used in any sheet and clean up empty columns
    const maxColumnIndices = {};
    Object.entries(workbook.Sheets).forEach(([sheetName, sheet]) => {
        const range = XLSX.utils.decode_range(sheet["!ref"] || "A1");
        const maxRow = range.e.r;
        // Find the last non-empty column
        let lastNonEmptyCol = -1;
        for (let c = 0; c <= range.e.c; c++) {
            let hasContent = false;
            for (let r = 0; r <= maxRow; r++) {
                const cellAddress = XLSX.utils.encode_cell({ r, c });
                if (sheet[cellAddress] && sheet[cellAddress].v !== undefined) {
                    hasContent = true;
                    break;
                }
            }
            if (hasContent) {
                lastNonEmptyCol = c;
            }
        }
        // Remove empty columns
        if (lastNonEmptyCol < range.e.c) {
            for (let c = range.e.c; c > lastNonEmptyCol; c--) {
                for (let r = 0; r <= maxRow; r++) {
                    const cellAddress = XLSX.utils.encode_cell({ r, c });
                    delete sheet[cellAddress];
                }
            }
            // Update the range
            range.e.c = lastNonEmptyCol;
            sheet["!ref"] = XLSX.utils.encode_range(range);
        }
        maxColumnIndices[sheetName] = lastNonEmptyCol;
    });
    // Track existing columns and their indices for all sheets
    const existingColumns = {};
    const columnIndices = {};
    Object.entries(workbook.Sheets).forEach(([sheetName, sheet]) => {
        existingColumns[sheetName] = new Set();
        columnIndices[sheetName] = {};
        Object.entries(sheet).forEach(([cell, value]) => {
            try {
                const { r, c } = XLSX.utils.decode_cell(cell);
                if (r === 0 &&
                    value &&
                    typeof value === "object" &&
                    "v" in value &&
                    typeof value.v === "string") {
                    const columnName = value.v;
                    // Try to extract language code from column name if it matches the format
                    let detectedLang = null;
                    if (option.translatedScriptFieldFormat) {
                        const langMatch = columnName.match(option.translatedScriptFieldFormat.replace("{locale}", "([^_]+)"));
                        if (langMatch && langMatch[1]) {
                            detectedLang = langMatch[1];
                        }
                    }
                    // If we detected a language, normalize it using aliases
                    if (detectedLang) {
                        const normalizedLang = aliasToLangMap[detectedLang] || detectedLang;
                        existingColumns[sheetName].add(normalizedLang);
                        columnIndices[sheetName][normalizedLang] = c;
                    }
                }
            }
            catch (_a) {
                // Ignore invalid cells
            }
        });
    });
    console.log("columnIndices", columnIndices);
    console.log("existingColumns", existingColumns);
    // Add missing translation columns if needed
    if (option.includeUnmatchedCols) {
        Object.entries(workbook.Sheets).forEach(([sheetName, sheet]) => {
            var _a;
            let currentColumnIndex = maxColumnIndices[sheetName];
            // Add new columns for languages that don't exist in any form
            for (const lang of availableLanguages) {
                const columnName = (_a = option.translatedScriptFieldFormat) === null || _a === void 0 ? void 0 : _a.replace("{locale}", lang);
                if (!columnName)
                    continue;
                // Check if this language already exists in any form (including aliases)
                const columnExists = existingColumns[sheetName].has(lang);
                if (!columnExists) {
                    currentColumnIndex++;
                    // Add column header
                    const headerCellAddress = XLSX.utils.encode_cell({
                        c: currentColumnIndex,
                        r: 0,
                    });
                    sheet[headerCellAddress] = {
                        v: columnName,
                    };
                    existingColumns[sheetName].add(lang);
                    columnIndices[sheetName][lang] = currentColumnIndex;
                }
            }
            maxColumnIndices[sheetName] = currentColumnIndex;
        });
    }
    for (const script of scripts) {
        const mapResult = translationMap[script.scriptId];
        if (!mapResult) {
            if (option.includeUnmatchedCols) {
                // For unmatched rows, create a new row with the original text
                const textCellAddress = XLSX.utils.encode_cell({
                    c: script.rawTextColumnIndex,
                    r: script.rawRowIndex,
                });
                workbook.Sheets[script.rawSheetName][textCellAddress] = {
                    v: script.text,
                };
            }
            continue;
        }
        const { text, translations } = mapResult;
        const textCellAddress = XLSX.utils.encode_cell({
            c: script.rawTextColumnIndex,
            r: script.rawRowIndex,
        });
        workbook.Sheets[script.rawSheetName][textCellAddress] = { v: text };
        // Track which languages we've written translations for
        const writtenLanguages = new Set();
        // First, write translations for existing columns
        if (translations) {
            Object.entries(translations).forEach(([langId, translation]) => {
                var _a;
                if (!translation)
                    return; // Skip if translation is undefined or null
                const normalizedLangId = aliasToLangMap[langId] || langId;
                const columnName = (_a = option.translatedScriptFieldFormat) === null || _a === void 0 ? void 0 : _a.replace("{locale}", normalizedLangId);
                if (!columnName)
                    return;
                // Get the column index from our stored indices
                const sheet = workbook.Sheets[script.rawSheetName];
                const sheetColumnIndices = columnIndices[script.rawSheetName];
                if (!sheetColumnIndices)
                    return;
                const columnIndex = sheetColumnIndices[normalizedLangId];
                if (columnIndex === undefined)
                    return;
                const cellAddress = XLSX.utils.encode_cell({
                    c: columnIndex,
                    r: script.rawRowIndex,
                });
                sheet[cellAddress] = { v: translation };
                writtenLanguages.add(normalizedLangId);
            });
        }
        // Then, add empty cells for languages that don't have translations
        if (option.includeUnmatchedCols) {
            for (const lang of availableLanguages) {
                if (writtenLanguages.has(lang))
                    continue;
                const columnName = (_a = option.translatedScriptFieldFormat) === null || _a === void 0 ? void 0 : _a.replace("{locale}", lang);
                if (!columnName)
                    continue;
                // Get the column index from our stored indices
                const sheet = workbook.Sheets[script.rawSheetName];
                const sheetColumnIndices = columnIndices[script.rawSheetName];
                if (!sheetColumnIndices)
                    continue;
                const columnIndex = sheetColumnIndices[lang];
                if (columnIndex === undefined)
                    continue;
                const cellAddress = XLSX.utils.encode_cell({
                    c: columnIndex,
                    r: script.rawRowIndex,
                });
                sheet[cellAddress] = { v: "" };
            }
        }
    }
    // Update sheet ranges to include new columns
    Object.entries(workbook.Sheets).forEach(([sheetName, sheet]) => {
        const range = XLSX.utils.decode_range(sheet["!ref"] || "A1");
        range.e.c = maxColumnIndices[sheetName];
        sheet["!ref"] = XLSX.utils.encode_range(range);
    });
});
exports.writeTranslation = writeTranslation;
